<!--<div>Address Group</div>-->
<div class="row">
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField [label]="'Address 1'"
                                [text]="address.line1"
                                [validators]="line1Validators"
                                (blur)="onBlur()"
                                [disabled]="disabled"
                                (onValueChange)="updateAddress('line1',$event)" maxlength ="100">
            </ValidatedTextField>
        </div>
    </div>
    <div class="col-8">
        <div class="input-wrapper">
            <ValidatedTextField [label]="'Address 2 (optional)'"
                                [text]="address.line2"
                                [validators]="line2Validators"
                                (blur)="onBlur()"
                                [disabled]="disabled"
                                (onValueChange)="updateAddress('line2',$event)" maxlength ="100">
            </ValidatedTextField>
        </div>
    </div>
</div>

<!--<div>Address Group</div>-->
<div class="row">
    <div class="col-6">
        <div class="input-wrapper">
            <ValidatedTextField [label]="'City'"
                                [text]="address.city"
                                [validators]="[notBlankValidator]"
                                (blur)="onBlur()"
                                [disabled]="disabled"
                                (onValueChange)="updateAddress('city', $event)" maxlength ="50">
            </ValidatedTextField>
        </div>
    </div>
    <div class="col-5">
        <div class="input-wrapper">
            <ValidatedDropDown class="wide" 
                               [selectedValue]="address.state.code"
                                [label]="'State'"
                                [disabled]="disabled"
                                (onValueChange)="updateAddress('state.code',$event)"
                                [options]="states"
                                (blur)="onBlur()">
            </ValidatedDropDown>
        </div>
    </div>
    <div class="col-3">
        <div class="input-wrapper">
            <ValidatedTextField [label]="'ZIP Code'"
                                [text]="address.zip"
                                [validators]="[notBlankValidator, zipCodeValidator, numericValidator]"
                                (blur)="onBlur()"
                                [disabled]="disabled"
                                (onValueChange)="updateAddress('zip', $event)" maxlength ="5">
            </ValidatedTextField>
        </div>
    </div>
    <div class="col-4">
        <div class="input-wrapper">
             <ValidatedTextField class="zip4" 
                                 [label]="'ZIP+4 (optional)'"
                                    [text]="address.zip4"                                                                       
                                    [disabled]="disabled"
                                    (onValueChange)="updateAddress('zip4', $event)" maxlength ="4">
                </ValidatedTextField>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <ErrorMessages [errorMessages]="errorMessages"></ErrorMessages>
    </div>
</div>
